module.exports = "/static/core/dist/slick.eot";